import React from 'react';
import { companies } from '../data/mock';

const LogoCarousel = () => {
  const track = [...companies, ...companies];
  return (
    <section className="relative bg-cream border-b border-stone-200 py-12 overflow-hidden" data-testid="logo-carousel">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-col md:flex-row md:items-center gap-6 md:gap-12">
        <p className="shrink-0 text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 md:max-w-[180px] leading-relaxed">
          Vertraut von Teams bei
        </p>
        <div className="relative flex-1 overflow-hidden">
          <div className="absolute left-0 inset-y-0 w-24 bg-gradient-to-r from-[#F7F5F0] to-transparent z-10" />
          <div className="absolute right-0 inset-y-0 w-24 bg-gradient-to-l from-[#F7F5F0] to-transparent z-10" />
          <div className="marquee-track items-center">
            {track.map((c, i) => (
              <div key={`${c.name}-${i}`} className="flex-shrink-0 mx-8 lg:mx-12 flex items-center justify-center h-12 w-[130px] grayscale opacity-55 hover:grayscale-0 hover:opacity-100 transition-all duration-300">
                <img src={c.logo} alt={c.name} className="max-h-9 w-auto object-contain" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoCarousel;
